/* eslint-disable */

import { Decimal } from 'decimal.js';
import Cookies from 'js-cookie';

export const checkCookieConsent = () => dispatch => {
  let cookieConsent = Cookies.get('CookieConsent');

  if (cookieConsent === true || cookieConsent === 'true')
    dispatch({ type: 'ACCEPT_COOKIES' });
  if (cookieConsent === false || cookieConsent === 'false') {
    Cookies.remove('CookieConsent');
  }
};

export const acceptCookies = () => dispatch => {
  dispatch({ type: 'ACCEPT_COOKIES' });
  dispatch({ type: 'OPEN_SUCCESS', payload: 'Cookies accepted' });
};

export const declineCookies = () => dispatch => {
  dispatch({ type: 'DECLINE_COOKIES' });
  dispatch({
    type: 'OPEN_ERROR',
    payload: "Cookies declined, you can't use Attributes",
  });
  setTimeout(() => {
    let cookieConsentBefore = Cookies.get('CookieConsent');
    Cookies.remove('CookieConsent');
    let cookieConsentAfter = Cookies.get('CookieConsent');
  }, 1000);
};

export const getDates = (startDate, endDate) => {
  var dates = [],
    currentDate = startDate,
    addDays = function(days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    };
  while (currentDate <= endDate) {
    dates.push(currentDate);
    currentDate = addDays.call(currentDate, 1);
  }
  return dates;
};

export const rad = x => {
  return (x * Math.PI) / 180;
};

export const getDistance = (p1, p2) => {
  var R = 6378137; // Earth’s mean radius in meter
  var dLat = rad(p2.lat - p1.lat);
  var dLong = rad(p2.lng - p1.lng);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(p1.lat)) *
      Math.cos(rad(p2.lat)) *
      Math.sin(dLong / 2) *
      Math.sin(dLong / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d; // returns the distance in meter
};

export const getAverageDistanceFromAsset = (
  currentAssetConsuming,
  producingAssets,
  graphData
) => {
  let averageDistance = 0;

  if (
    !(producingAssets && producingAssets.length > 0) ||
    !currentAssetConsuming ||
    !producingAssets
  ) {
    return averageDistance;
  }

  const assetConsumingLatLng = {
    lat: parseFloat(currentAssetConsuming.gpsLatitude),
    lng: parseFloat(currentAssetConsuming.gpsLongitude),
  };

  const prodAssetsRatios = graphData.doughnutChartData.map(data => data);
  prodAssetsRatios.pop();

  let totalRatio = 0;
  prodAssetsRatios.map(prodAssetRatio => {
    totalRatio += prodAssetRatio;
    return true;
  });

  const ratiosProduction = prodAssetsRatios.map(ratio => {
    return ratio / totalRatio;
  });

  const assetsWithDistanceAndTotalEnergy = producingAssets.map(
    (asset, index) => {
      const assetWithDistanceAndTotalEnergy = {
        id: asset.id,
        distance: 0,
        energyRatio: 0,
      };

      const assetLatLng = {
        lat: parseFloat(asset.gpsLatitude),
        lng: parseFloat(asset.gpsLongitude),
      };

      assetWithDistanceAndTotalEnergy.distance = getDistance(
        assetConsumingLatLng,
        assetLatLng
      );
      assetWithDistanceAndTotalEnergy.energyRatio = ratiosProduction[index];

      return assetWithDistanceAndTotalEnergy;
    }
  );

  assetsWithDistanceAndTotalEnergy.map(asset => {
    averageDistance += asset.distance * asset.energyRatio;
  });

  return averageDistance; //in meters
};

export const getCo2DataWithoutDispatch = async () => {
  let url = process.env.REACT_APP_API_URL + '/api/co2';

  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
  });
  const co2 = await response.json();
  return co2;
};

export const getTransportCertificates = async () => {
  let url = process.env.REACT_APP_API_URL + '/api/deliveries/certificates';

  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
  });
  const json = await response.json();

  return json;
};

export const getCo2Data = () => async dispatch => {
  dispatch({ type: 'GET_CO2_START' });

  const url = process.env.REACT_APP_API_URL + '/api/co2';

  return await fetch(url, {
    method: 'GET',
    credentials: 'include',
  })
    .then(res => res.json())
    .then(async co2 => {
      dispatch({ type: 'GET_CO2_SUCCESS', payload: co2 });
    })
    .catch(error => {
      dispatch({ type: 'GET_CO2_FAIL' });
    });
};

export const toggleDateFilter = () => dispatch => {
  dispatch({ type: 'TOGGLE_DATE_FILTER' });
};

export const hideDateFilter = () => dispatch => {
  dispatch({ type: 'HIDE_DATE_FILTER' });
};

export const displayDateFilter = () => dispatch => {
  dispatch({ type: 'DISPLAY_DATE_FILTER' });
};

export const toggleStacked = () => dispatch => {
  dispatch({ type: 'TOGGLE_STACKED' });
};

export const setUnit = unit => dispatch => {
  dispatch({ type: 'SET_UNIT', payload: unit });
};

export const setMapZoomAndCenter = (center, zoom) => dispatch => {
  dispatch({
    type: 'SET_MAP_ZOOM_CENTER',
    payload: { center: center, zoom: zoom },
  });
};

export const getEnergyInTextWithUnit = wh => {
  let energyInWh = new Decimal(wh);

  let energyConverted = energyInWh;
  let energyUnit = 'Wh';

  if (10 ** 3 <= wh && wh < 10 ** 6) {
    energyConverted = energyInWh.dividedBy(10 ** 3);
    energyUnit = 'kWh';
  } else if (10 ** 6 <= wh && wh < 10 ** 9) {
    energyConverted = energyInWh.dividedBy(10 ** 6);
    energyUnit = 'MWh';
  } else if (10 ** 9 <= wh) {
    energyConverted = energyInWh.dividedBy(10 ** 9);
    energyUnit = 'GWh';
  }

  return {
    value: energyConverted.toNearest(0.1, Decimal.ROUND_HALF_UP).toNumber(),
    unit: energyUnit,
  };
};

// a little function to help us with reordering the result
export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const getDistanceInMeters = (p1, p2) => {
  var R = 6378137; // Earth’s mean radius in meter
  var dLat = rad(p2.lat - p1.lat);
  var dLong = rad(p2.lng - p1.lng);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(p1.lat)) *
      Math.cos(rad(p2.lat)) *
      Math.sin(dLong / 2) *
      Math.sin(dLong / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d; // returns the distance in meter
};



// WEBPACK FOOTER //
// ./src/actions/UtilsActions.js